import styled from 'styled-components'

import Colors from 'builder/styles/colors'
import Button, { ButtonTheme } from 'builder/components/Button'
import { Icon20 } from 'builder/components/Icon'
import { FontWeights, Typography } from 'builder/styles/typography'

import ProgressImage from './assets/progress.png'

export const Image = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${ProgressImage});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`

export const CloseButton = styled.button`
  position: absolute;
  top: 24px;
  right: 24px;
  border: none;
  cursor: pointer;
`

export const InitialActionButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
`

export const InitialContinueButton = styled(Button)`
  color: ${Colors.White};
  background-color: ${Colors.Green50};

  &:hover,
  &:focus-visible {
    background-color: ${Colors.Green60};
  }
`

export const InitialCloseButton = styled(Button).attrs({
  theme: ButtonTheme.ghost,
})``

export const ProgressActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  padding: 11px;
  border-radius: 8px;
  border: 1px solid ${Colors.Neutral15};
  background: ${Colors.White};
`

export const ActionText = styled.p`
  ${Typography.Body}
  ${FontWeights.Regular}

  color: ${Colors.Neutral90};
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`

export const Icon = styled(Icon20.ChevronRightRegular)`
  color: ${Colors.Neutral80};
`

export const AnimationVideo = styled.video`
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  margin: 0;
  padding: 0;
`
